<template>
  <div class="slider">
    <swiper
      v-if="portfolioPosts.length > 0"
      @slideChange="animateSlideChange()"
      class="slider__body"
      ref="mySwiper"
      :options="swiperOption"
      >
      <swiper-slide v-for="(slide,index) in portfolioPosts" v-bind:key="index" class="slider__slide" :id="'slide'+index">
        <div class="slider__slide-img">
          <!-- {{ slide.acf.photo_main }} -->
          <img v-if="!slide.acf.video && slide.acf.photo_main" :src="slide.acf.photo_main.url" alt="">
          <video v-if="slide.acf.video && slide.acf.video_link" playsinline autoplay loop muted>
            <source :src="slide.acf.video_link" type="video/mp4">
          </video>
        </div>
        <router-link :to="{ name: 'Portfolio', params: { slug: slide.slug }}" class="slider__title" v-html="splitWords(slide.title.rendered)">
        </router-link>
      </swiper-slide>
      <div class="slider__btn slider__btn--prev" slot="button-prev">
        <nextButton  class="icon"/>
      </div>
      <div class="slider__btn slider__btn--next" slot="button-next">
        <prevButton  class="icon"/>
      </div>

    </swiper>
            <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
  </div>
</template>

<script>
import axios from 'axios'
import nextButton from '../assets/arrow_left.svg'
import prevButton from '../assets/arrow_right.svg'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { TweenMax } from 'gsap'

const BASE_URL = process.env.BASE_URL

export default {
  name: 'frontPage',
  components: {
    swiper,
    swiperSlide,
    nextButton,
    prevButton
  },
  data () {
    return {
      show: false,
      portfolioAcf: '',
      portfolioPosts: [],
      swiperOption: {
        // init: false,
        loop: true,
        // loopedSlides: 4,
        slidesPerView: 1,
        speed: 800,
        observe: true,
        navigation: {
          nextEl: '.slider__btn--next',
          prevEl: '.slider__btn--prev'
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
        on: {
          init: () => {
            // document.querySelector('.swiper-scrollbar-drag').appendChild('<div class="drag-dot"></div>')
            this.animateSlider()
            TweenMax.staggerTo(
              'body',
              2,
              { backgroundColor: this.portfolioPosts[0].acf.photo_color, color: '#fff' },
              0.5
            )
            // TweenMax.staggerTo(
            //   '.logo',
            //   0.1,
            //   { fill: '#fff' },
            //   0.5
            // )
            const slideHtml = document.querySelector('.swiper-slide-active')
            const letters = slideHtml.children[1].childNodes
            TweenMax.staggerTo(
              [slideHtml.querySelector('.slider__title')],
              0.5,
              {
                opacity: 1,
                delay: 0.7
              }
            )
            setTimeout(() => {
              letters.forEach((element, index) => {
                // console.log(element)
                TweenMax.staggerFrom(
                  [element],
                  0.7,
                  {
                    // rotation: 40,
                    // x: 10,
                    opacity: 0,
                    y: 20,
                    delay: index * (0.5 / letters.length)
                  }
                )
              })
            }, 500)
          },
          slideChange: () => {
          },
          onSlideChangeEnd: () => {

          }
        }
      },
      startAnimation: ''
    }
  },
  created () {
    this.getPosts()
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    let footer = document.querySelector('.footer')
    footer.style.display = 'flex'
    TweenMax.staggerTo(
      [footer],
      0.8,
      {
        y: 0,
        rotation: 0,
        scale: 1,
        opacity: 1,
        onComplete: () => {
          // footer.style.display = 'none'
        }
      },
      1
    )
  },
  methods: {
    async getPosts () {
      let url = BASE_URL + '/wp-json/wp/v2/portfolio'

      try {
        const res = await axios.get(url)
        this.portfolioPosts.shift()
        for (let index = 0; index < res.data.length; index++) {
          this.portfolioPosts.push(res.data[index % res.data.length])
        }
      // this.posts = response.data
      } catch (e) {
        this.errors.push(e)
      }
    },
    animateSlider () {
      TweenMax.staggerFrom(
        '.slider',
        1,
        {
          y: [30, 0],
          rotation: 0,
          scale: [ 1.05, 0 ],
          opacity: 0
        },
        0.5
      )
    },
    animateSlideChange () {
      console.log(this.$refs.mySwiper.swiper.previousIndex, this.$refs.mySwiper.swiper.activeIndex)
      const index = this.$refs.mySwiper.swiper.realIndex
      const activeIndex = (this.$refs.mySwiper.swiper.activeIndex === 0) ? 0 : this.$refs.mySwiper.swiper.activeIndex
      const prevIndex = (this.$refs.mySwiper.swiper.activeIndex === 0) ? 1 : this.$refs.mySwiper.swiper.activeIndex - 1
      const slideHtml = document.querySelectorAll('.slider__slide')[activeIndex]
      const slideHtmlBefore = document.querySelectorAll('.slider__slide')[prevIndex]
      const letters = slideHtml.children[1].childNodes
      TweenMax.staggerTo(
        'body',
        1.2,
        { backgroundColor: this.portfolioPosts[index].acf.photo_color },
        0.5
      )
      TweenMax.staggerTo(
        [slideHtmlBefore.querySelector('.slider__title')],
        0.3,
        {
          opacity: 0,
          delay: 0
        }
      )
      TweenMax.staggerTo(
        [slideHtml.querySelector('.slider__title')],
        0.5,
        {
          opacity: 1,
          delay: 0.7
        }
      )
      setTimeout(() => {
        letters.forEach((element, index) => {
        // console.log(element)
          TweenMax.staggerFrom(
            [element],
            0.7,
            {
              // rotation: 40,
              // x: 10,
              opacity: 0,
              y: 20,
              delay: index * (0.5 / letters.length)
            }
          )
        })
      }, 700)
    },
    splitWords (title) {
      return title.replace(/([\S^a-z])|\w/g, "<span class='letter'>$&</span>")
    }
  },
  beforeRouteLeave (to, from, next) {
    TweenMax.staggerTo(
      '.slider',
      0.8,
      {
        y: -100,
        rotation: 0,
        scale: 1,
        opacity: 0
      },
      1
    )
    let footer = document.querySelector('.footer')
    TweenMax.staggerTo(
      [footer],
      0.8,
      {
        y: 200,
        rotation: 0,
        scale: 1,
        opacity: 0,
        onComplete: () => {
          footer.style.display = 'none'
        }
      },
      1
    )
    TweenMax.staggerTo(
      '.swiper-scrollbar',
      0.8,
      {
        opacity: 0
      },
      1
    )
    setTimeout(() => {
      next()
    }, 800)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Frontpage.vue